import graphql__a2566db78168ca92f886 from "./__generated__/InvoiceHeader_invoice.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useFragment} from "react-relay/hooks";
import {useIntl} from "react-intl";

type InvoiceHeaderProps = {
    invoice: any
}

const InvoiceHeader: React.FC<InvoiceHeaderProps> = (props) => {
    const intl = useIntl();
    const invoice = useFragment(
        graphql__a2566db78168ca92f886,
        props.invoice
    )

    return (
        <div className="mt-6 mx-auto px-4 sm:px-6 lg:px-8">
            <div className="ml-4 mt-4 flex flex-wrap items-center justify-between">
                <div className="ml-4 flex items-center">
                    <div>
                        <h2 className="text-xl font-medium text-gray-700">{invoice.customerAccount.customerName}</h2>
                        <h1 className="text-2xl font-bold text-gray-900">
                            {invoice.type === 'REVERSE' ? intl.formatMessage({id: 'header.invoice.type.reverse'}) : intl.formatMessage({id: 'header.invoice.type.invoice'})} {invoice.invoiceNumber}
                        </h1>
                        <p className="text-sm font-medium text-gray-500">{invoice.id}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvoiceHeader;
